import { ref, watch } from 'vue'

const KEY = 'piston-theme'
const mode = ref(localStorage.getItem(KEY) || 'light')

function apply() {
  const v = mode.value === 'system'
    ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    : mode.value
  document.documentElement.setAttribute('data-theme', v)
  document.body.setAttribute('data-theme', v)
}

apply()

watch(mode, () => {
  localStorage.setItem(KEY, mode.value)
  apply()
})

export function useAppTheme() {
  return {
    mode,
    toggle() { mode.value = mode.value === 'dark' ? 'light' : 'dark' },
    setMode(m) { mode.value = m },
    isDark() { return mode.value === 'dark' },
  }
}
